import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGB, getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem 0rem',
    borderRadius: '0.5rem',
    border: `2px dashed ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    userSelect: 'none',
    cursor: 'pointer',
    transition: 'all 300ms ease-in',

    '&:hover': {
      backgroundColor: `rgba(${getRGB(theme.palette.primary.main)},0.06)`,
    },

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',

    '& p': {
      fontFamily: 'Nunito',
      fontSize: '1.2rem',
      fontWeight: '400',
      lineHeight: '1.5rem',
      color: theme.palette.primary.main,
    },

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeight: '400',
      lineHeight: '1.25rem',
      color: getRGBA('#0F0F1E', 0.6),
    },
  },

  fileListRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '1rem',
    marginBottom: '1rem',
  },

  fileItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeiht: '400',
      lineHeight: '1.5rem',
      lineClamp: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
    },
  },

  articleIcon: {
    fontSize: '1.6rem !important',
    color: '#1C1B1F !important',
  },

  deleteIcon: {
    color: '#DE3730 !important',
    fontSize: '1.6rem !important',
    cursor: 'pointer',
  },
}))

export { useStyles }
